import { ConfigModel } from '../interfaces/config';

export interface CredentialInterface {
	permissions: any;
	currentUserRoles: any;
}

export class CredentialModel implements CredentialInterface, ConfigModel {
	public config: any;


	// default permissions
	public permissions: any = {
		SUBSCRIBER: ['canDoAnything'],
		ADMIN: ['canDoAnything'],
		USER: ['canDoLimitedThings']
	};

	// store an object of current user roles
	public currentUserRoles: any = {};

	//user data
	public userData: any ={
		 Email:"",
		 Name:"",
		 type:"",
		 IdSubscriber:"",
		 SusbscriberName:""
	}

	constructor() {}
}
